export default __webpack_public_path__ + "static/media/Sans.df45c325.webp";